import './Setting.scss';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Stack, Typography, useTheme } from '@mui/material';

import CompanyProfileSetting from './Components/CompanyProfileSetting';
import ProfileSetting from './Components/ProfileSetting';
import NotificationSetting from './Components/NottficationSetting';
import PlanSetting from './Components/PlanSetting';

import CompanyIcon from '../../../assets/images/company.svg';
import PersonIcon from '../../../assets/images/person.svg';
import NotificationIcon from '../../../assets/images/bell.svg';
import PlanIcon from '../../../assets/images/plans.svg';
import EditCompanyProfile from './Components/EditCompanyProfile';
import EditTraderProfile from './Components/EditTraderProfile';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { checkPermission } from '../../../redux/features/authSlice';
import { useTranslation } from 'react-i18next';

const menuList = [
  { lable: 'Company profile', icon: CompanyIcon },
  { lable: 'User profile', icon: PersonIcon },
  { lable: 'Notifications', icon: NotificationIcon },
  { lable: 'Plans', icon: PlanIcon },
];

export default function Settings() {
  const theme = useTheme();
  const { user } = useSelector((state) => state.auth);
  const [activeMenuIndex, setActiveMenuIndex] = useState(0);
  const [openEditCompany, setOpenEditCompany] = useState(false);

  const settingPermission = useSelector((state) => checkPermission(state, 'Settings', 'Manage Company Profile'));
  const settingPlanPermission = useSelector((state) => checkPermission(state, 'Settings', 'Manage Plans'));

  const location = useLocation();

  const { t } = useTranslation();

  useEffect(() => {
    if (location?.state?.index) {
      setActiveMenuIndex(location?.state?.index);
    }
  }, [location?.state?.index])

  const sx = {
    mb: '8px',
    height: '48px',
    justifyContent: 'flex-start',
    textTransform: 'none',
  };

  const handleMenuChange = (index) => {
    if (index !== activeMenuIndex) {
      setActiveMenuIndex(index);
    }
  };

  const menus = menuList.filter((res, index) => {
    if (index === 0 && !settingPermission.viewAccess) {
      return false;
    }
    if (index === 3 && !settingPlanPermission.viewAccess) {
      return false;
    }
    return true
  })

  return (
    <Stack
      flex={1}
      direction="row"
      className="desktopModeSettingConatiner"
    >
      <Stack
        direction="column"
        sx={{ width: '256px', minWidth: '256px' }}
        className="sideMenu"
      >
        <Stack
          justifyContent="center"
          className="headerTitle"
        >
          <Typography
            className="ff-Roboto  fw-medium"
            sx={{ color: theme.palette.primary.text }}
          >
            {t('Settings')}
          </Typography>
        </Stack>

        <Stack flexGrow={1}>
          {menus.map((item, index) => (
            <Stack
              direction="row"
              sx={{ color: theme.palette.primary.text }}
              alignItems="center"
              onClick={() => handleMenuChange(index)}
              className={`ff-Roboto fw-medium fs-14 px-[16px] navButton ${activeMenuIndex === index ? ' activeBtn' : ''}`}
              key={index}
            >
              <img
                src={item.icon}
                alt="icon"
              />
              {t(item.lable)}
            </Stack>
          ))}
        </Stack>
      </Stack>
      <Stack flexGrow={1}>
        <Stack
          justifyContent="center"
          className="headerTitle content"
        >
          <Typography
            className="ff-Roboto  fw-medium "
            sx={{ color: theme.palette.primary.text }}
          >
            {t(`${menus[activeMenuIndex].lable}`)}
          </Typography>
        </Stack>
        <Stack
          flexGrow={1}
          className="sideMenuContent "
          style={{ padding: activeMenuIndex === 3 ? '0px' : '24px 122px' }}
        >
          {activeMenuIndex === 0 && settingPermission.viewAccess && <CompanyProfileSetting onClickEdit={() => setOpenEditCompany(true)} />}
          {((activeMenuIndex === 1 && settingPermission.viewAccess) || (activeMenuIndex === 0 && !settingPermission.viewAccess)) && <ProfileSetting />}
          {((activeMenuIndex === 2 && settingPermission.viewAccess) || (activeMenuIndex === 1 && !settingPermission.viewAccess)) && <NotificationSetting />}
          {((activeMenuIndex === 3 && settingPermission.viewAccess) || (activeMenuIndex === 2 && !settingPermission.viewAccess)) && <PlanSetting />}
        </Stack>
      </Stack>
      {openEditCompany && user.type !== 'trader' && (
        <EditCompanyProfile
          modelOpen={openEditCompany}
          handleClose={() => setOpenEditCompany(false)}
        />
      )}
      {openEditCompany && user.type === 'trader' && (
        <EditTraderProfile
          modelOpen={openEditCompany}
          handleClose={() => setOpenEditCompany(false)}
        />
      )}
    </Stack>
  );
}
